import { useContext } from "react";
import InputsContext from "contexts/InputsContext";
const useInputs = () => useContext(InputsContext);
export default useInputs;
